import React, { useState, useEffect } from 'react'
import '../Footer/Footer.css';
import footerBanner from '../../assets/images/footer2.jpg'
import footerBannerMobile from '../../assets/images/footer2.jpg'
// import footerBanner from '../../assets/images/new-footer.jpg'
// import footerBannerMobile from '../../assets/images/footerBannerMobile.jpg'

import { Link, useParams } from 'react-router-dom';
import { FaInstagram, FaLinkedin } from "react-icons/fa";
import footerContent from '../../JSONData/footer.json';
import axios from 'axios';
import config from '../../config';

export default function Footer() {
  const [servicesOpen, setServicesOpen] = useState(false);

  const [loading, setLoading] = useState(true);
  const { lang } = useParams();
  const content = (footerContent && footerContent[lang]) ? footerContent[lang] : footerContent.en;
  const [services, setServices] = useState([]);

  const toggleServices = () => setServicesOpen(!servicesOpen);
  const fetchServices = async () => {
    try {
      const response = await axios.get(
        `${config.BASE_URL}/api/admin/services${lang ? `?lang=${lang}` : ''}`,
        { withCredentials: true }
      );
      if (response.data?.data) {
        setServices(response.data?.data);
      }
    } catch (err) {
      console.log('Failed to fetch languages');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices()
    const handleClickOutside = (event) => {
      if (servicesOpen && !event.target.closest('.footer-services-container')) {
        setServicesOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [servicesOpen]);
  return (
    <>
      <footer className='footer position-relative d-flex flex-column justify-between'>
        <picture className="cover top-overlay bottom-overlay position-absolute top-0 start-0">
          <source media="(max-width:768px)" srcSet={footerBannerMobile} />
          <img className="cover" src={footerBanner} alt="" />
        </picture>
        <div className='content-block pt-40 d-pt-90 pb-30 d-pb-50'>
          <div className='container'>
            <div className='grid-blocks d-grid d-column-2 gap-40 d-gap-50 pb-40 d-pb-0'>
              <div className='grid-block'>
                <div className='summary-block d-d-flex flex-column justify-center'>
                  <h2 className='fw-200 mb-10'>{content.cta.title}</h2>
                  <div className='text-block fw-200'>{content.cta.subtitle}</div>
                </div>
              </div>
              <div className='grid-block d-d-flex justify-end align-center'>
                <div className='button-block'>
                  <Link to='/contact-us' className='button button-primary'>{content.cta.button}</Link>
                </div>
              </div>
            </div>
            <div className='grid-block d-pt-60 color-light'>
              <div className='menu-block'>
                <ul>
                  <li className='d-mb-5'><Link to='/about' className='fw-200'>{content.menu.about}</Link></li>
                  <li className='d-mb-5'><Link to='/project_index' className='fw-200'>{content.menu.projects}</Link></li>
                  <li className='d-mb-5'><Link to='/blogs' className='font-size-16 fw-200 capitalize'>{content.menu.news}</Link></li>

                  {/* Services Subsection */}
                  <div className='footer-services-container'
                    onMouseEnter={() => setServicesOpen(true)}
                    onMouseLeave={() => setServicesOpen(false)}>
                    <li className='d-mb-5 ' onClick={toggleServices}>
                      <span className='fw-200 cursor-pointer'>
                        {content.menu.services.label}
                        <span className={`footer-services-arrow ${servicesOpen ? 'open' : ''}`}>
                          <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.60224 6.94085L1.04733 2.38591C0.827648 2.16623 0.827648 1.81008 1.04733 1.59042L1.57859 1.05916C1.79789 0.839859 2.15332 0.839437 2.37314 1.05823L6 4.66809L9.62684 1.05823C9.84666 0.839437 10.2021 0.839859 10.4214 1.05916L10.9526 1.59042C11.1723 1.8101 11.1723 2.16626 10.9526 2.38591L6.39776 6.94085C6.17808 7.16051 5.82192 7.16051 5.60224 6.94085Z" fill="white" />
                          </svg>

                        </span>
                      </span>
                    </li>
                    <div className={`footer-services-dropdown ${servicesOpen ? 'open' : ''}`}>
                      <li className='d-mb-5 footer-services-item'>
                        <Link to='/for-contractors' className='fw-200'>{content.menu.services.contractors}</Link>
                      </li>
                      <li className='d-mb-5 footer-services-item'>
                        <Link to='/for-architects-and-designers' className='fw-200'>{content.menu.services.architects}</Link>
                      </li>
                      <li className='d-mb-5 footer-services-item'>
                        <Link to='/lighting-facade' className='fw-200'>{content.menu.services.facade}</Link>
                      </li>
                      <>
                        {services.map((service) => (
                          <li key={service._id} className='d-mb-5 services-item'>
                            <Link
                              to={`/services/${service?.slug}`}
                              className='font-size-16 fw-200 capitalize'
                            >
                              {service?.hero?.title}

                            </Link>
                          </li>
                        ))}
                      </>
                    </div>
                  </div>

                  <li className='d-mb-5'><Link to='/contact-us' className='fw-200'>{content.menu.contact}</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className='bottom-footer color-light pt-10 pb-30'>
          <div className='container'>
            <div className='grid-blocks d-flex align-center justify-between'>
              <div className='grid-block'>
                <ul className='d-flex align-center gap-10 d-gap-30'>
                  <li className=''><Link to='/privacy-policy' className='fw-200'>{content.bottom.privacy}</Link></li>
                  <li className=''><Link to='/terms-of-use' className='fw-200'>{content.bottom.terms}</Link></li>
                </ul>
              </div>
              <div className='grid-block'>
                <ul className='social-icon d-flex align-center justify-between gap-10'>
                  <li><Link to='https://www.instagram.com/luminicos__/?hl=en' className='align-center justify-center'><FaInstagram /></Link></li>
                  <li><Link to='https://www.linkedin.com/company/luminicos  ' className='align-center justify-center'><FaLinkedin /></Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
